// Copyright 2025 Sorama B.V.

import { ReportableMeasurement } from "datatypes/ReportableMeasurement";
import { SorXMeasurement } from "datatypes/SorXMeasurement";

/**
 * Helper class for managing mixed values and property access in measurements
 */
export class MeasurementPropertyHelpers {
    /**
     * Gets a nested value from an object using dot notation
     */
    public static getNestedValue(obj: Record<string, unknown>, path: string): unknown {
        return path.split(".").reduce((current, key) => (current as Record<string, unknown>)?.[key], obj);
    }

    /**
     * Checks if a property has mixed values across multiple reports of the same type
     */
    public static hasMixedValues(
        measurement: ReportableMeasurement<SorXMeasurement> | null,
        selectedReports: ReportableMeasurement<SorXMeasurement>[],
        path: string
    ): boolean {
        if (!measurement?.data) return false;

        const reports = selectedReports.filter((r) => r.data.type === measurement.data.type);
        const values = reports.map((r) => this.getNestedValue(r.data, path));

        // Mixed values detected if not all values are the same
        return !values.every((v) => v === values[0]);
    }
}
